import { render } from "./_PermitChecklistPost.vue?vue&type=template&id=0d4d80d5"
import script from "./_PermitChecklistPost.vue?vue&type=script&lang=js"
export * from "./_PermitChecklistPost.vue?vue&type=script&lang=js"

import "./_PermitChecklistPost.vue?vue&type=style&index=0&id=0d4d80d5&lang=css"

import exportComponent from "C:\\AgentPools\\FAOAgentPool\\_work\\32\\s\\WEPTW_Web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__